import { Document } from "@syadem/kairos-citizen-js";
import { Service } from "../service";
import { ActionResult } from "../../actionResult";
import { Apis } from "../../network/apis";

interface Payload {
  healthRecordId: string;
  documentId: string;
  attachments: File[];
  onProgressUpdate?: (fileIndex: number, progress: number) => void;
}

export class AttachDocumentFilesService implements Service<Payload, Document> {
  constructor(
    private readonly apis: Apis
  ) { }

  async call({
    healthRecordId,
    documentId,
    attachments,
    onProgressUpdate,
  }: Payload): Promise<ActionResult<Document>> {
    let apiDocument: Document | undefined;

    for (let i = 0; i < attachments.length; i++) {
      const file = attachments[i];
      apiDocument = await this.apis.documentFileApi.attachFiles(healthRecordId, documentId, [file], (progress) =>
        onProgressUpdate?.(i, progress),
      );
    }

    if (!apiDocument) {
      return {
        type: "error",
      };
    }

    return {
      type: "success",
      value: apiDocument,
    };
  }
}